import type { BottleType } from "../schema";
import { INK, centred, doc, hairline, imageSlot, labelWidth, rect } from "./kit";
import type { LabelTemplate } from "./types";

// Colour band: the visitor's logo on a burgundy band across the top, a line
// of thanks beneath on a warm-white panel. The band is the label background
// itself, so nothing filled sits over the slot: an upload always moves to the
// back of the stack (elements.ts placeImage) and would hide under a filled
// band. The panel runs to the 3 mm margin, so each bottle gets its own layout.
export const logoBand: LabelTemplate = {
  key: "logo-band",
  name: "Colour band",
  occasion: "corporate",
  style: "Logo on a burgundy band",
  description: "Your logo on a burgundy band — send a light version of your logo.",
  hasImageSlot: true,
  slot: "logo",
  build(bottle: BottleType) {
    const W = labelWidth(bottle);
    const cx = W / 2;
    return doc(bottle, INK.burgundy, [
      imageSlot({ x: cx - 20, y: 9, width: 40, height: 18 }, "Add your logo"),
      rect(INK["warm-white"], { x: 3, y: 36, width: W - 6, height: 61 }, 0.3, INK["warm-white"]),
      centred(bottle, { text: "With our compliments", font: "cormorant", size: 4.5, color: INK.charcoal, baseline: 50, tracking: 0.02 }),
      centred(bottle, { text: "for a year of partnership", font: "cormorant", italic: true, size: 2.8, color: INK.charcoal, baseline: 57, tracking: 0.02 }),
      hairline(INK.bronze, cx, 62.5, 30),
      centred(bottle, { text: "Your company · 2026", font: "montserrat", size: 1.8, color: INK.charcoal, baseline: 88, tracking: 0.2 }),
    ]);
  },
};
